import React, {useState, useEffect, useCallback, useMemo} from "react";
import {connect} from "react-redux"
import { motion } from "framer-motion"
import useMediaQuery from "./../utilities/useMediaQuery"

import ShopCard from "./shopcart/ShopCart";
import Products from "./product/Products";
import Style from "./ShopBase.css";


const prodCountStyle = {
    "display": "inline-bloc",
    "color": "white",
    "backgroundColor": "#CCC",
    "fontSize": "0.6rem",
    //"marginBottom": "10px"
}

const displayCardStyle = {
     "width":"180px",
    "position": 'fixed'
}

const ShopBase = (props)=> {

    const [asData, setAsData] = useState(false)
    const [products, setProducts] = useState([])
    const [cartOpen, setCartOpen] = useState(false)
    const [selectedProduct, setSelectedProduct] = useState()

    let pageIsLarge = useMediaQuery('(min-width : 2000px)')

    useEffect(() => {
        fetchProducts();
        fetchShopData()

    }, [])

    useEffect(() => {
        (pageIsLarge)?props.toggleCart():null;
    }, [products])

    useEffect(()=>{

    },[pageIsLarge])

    useEffect(()=>{
        //console.log(selectedProduct)
    }, [selectedProduct])


    const fetchProducts = ()=>{
        axios.get('/Api/shop/product')
            .then(result => {
                setProducts(result.data)
            }).catch(err => {
            console.log(err)
        })
    }

    const fetchShopData = ()=>{
        axios.get('/Api/shop')
            .then(result => {
                props.setShop(result.data)
                //props.setStripePubKey(result.data.stripe_pk)
            }).catch(err => {
            console.log(err)
        })
    }

    const shopcartDisplayVariants = {
        "open":{"right": 56, opacity: 1, position: 'fixed' },
        "close" :{"right": -100, opacity: 0 }, position: 'fixed'
    }

    const handelSelectedProduct = (e)=>{
        setSelectedProduct(e);
    }


    return (

            <div className={" h-100"} >
                <div
                    style={{"backgroundColor": "var(--theme-page-background)", "color": "var(--theme-color) "}}
                    className={"rounded rounded-full"}
                >
                    <div className={"d-flex flex-column flex-md-row justify-content-between align-items-center border-bottom p-2 "} >
                        <h3 className={"font-weight-normal"} style={{"fontSize": "30px"}}>
                            <i
                                className="bi bi-arrow-left-short fa-1x ueShopCloseBtn"
                                onClick={(e)=>props.showCenterSection(false)}
                            />
                            Nos Formulaires
                        </h3>
                        <div className={"d-flex flex-row"}>
                                {(selectedProduct)?
                                    <div style={{"fontSize":"1.1rem"}} className={"d-flex flex-row mr-4"}>
                                        <span className={"text-primary font-weight-bold text-uppercase mr-3"}>{selectedProduct.code} </span>
                                        {selectedProduct.label}
                                        <div className={"text-right"}>
                                            <div className={"d-inline-flex ml-4 font-weight-bold d-block"}>{selectedProduct.amount}.00 € TTC</div>
                                            <div className={"font-weight-light text-muted"} style={{"fontSize":"0.9rem"}}>{selectedProduct.amount-(selectedProduct.amount*0.2)}.00 € HT</div>
                                        </div>
                                    </div>
                                    :null
                                }
                        {
                            (props.shopProducts && props.shopProducts.length > 0) ?
                                <div className={"btn btn-sm btn-outline-primary pb-0"} onClick={props.toggleCart}>
                                    Selectionner
                                    <i className="fas fa-shopping-cart"/>
                                    <span
                                    className={"badge badge-secondary"}
                                    style={prodCountStyle}>{props.shopProductCount}</span>
                                </div>
                                : <div className={"btn btn-sm btn-outline-primary"} onClick={props.toggleCart}>
                                    <i className="fas fa-shopping-cart"/>
                                </div>
                        }
                        </div>
                    </div>
                    <div className={""}>
                        <div className="">
                            <Products items={products} selectedProduct={handelSelectedProduct}/>
                        </div>
                        <motion.div style={displayCardStyle}
                                    animate={props.displayCart?"open":"close"}
                                    variants={shopcartDisplayVariants}
                                    initial={false}
                        >
                            <ShopCard />
                        </motion.div>
                    </div>
                </div>
            </div>
    )
}

const mapStateToProps = state => {
    return {
        userId: state.MeReducer.id,
       shopProducts: state.ShopCartReducer.products,
        shopProductCount : state.ShopCartReducer.productCount,
        displayCart: state.ShopCartReducer.displayCart
    }
}

const mapDispatchTProps = dispatch => {
    return {
        updateStructureInfo: (e) => dispatch( {type: 'UPDATE_STRUCTURE_INFO', data:e}),
        toggleCart: () => dispatch( {type: 'TOGGLE_CART'}),
        setShop: (e) => dispatch({type: 'ADD_SHOP', data: e}),
        setStripePubKey: (e) => dispatch({type: 'SET_PUB_KEY', data: e}),
        showCenterSection: (e) => dispatch( {type: 'SHOW_CENTER_SECTION', data:e}),
    }
}

export default connect(mapStateToProps, mapDispatchTProps)(ShopBase);





